import axios from 'axios';

// URL and endpoint constants
// Codeweb
const INDEX_URL = '/codeweb'; // GET

export default {
  // delete
  delete(id) {
    return axios.delete(`${INDEX_URL}/${id}`);
  },
};



// WEBPACK FOOTER //
// ./src/api/v1/codeweb.js